import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { SocialLoginProvider } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';

import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  selector: 'app-social-login',
  templateUrl: './social-login.component.html',
  styleUrls: ['./social-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, ImmomioButtonComponent]
})
export class SocialLoginComponent {
  readonly horizontalLayout = input(false);
  readonly showText = input(true);
  readonly login = output<string>();

  public socialLoginProvider = SocialLoginProvider;

  public onSocialLogin(loginMethod: string) {
    this.login.emit(loginMethod);
  }
}
